import React from "react";
import { motion } from "framer-motion";
import "./special.css";

function Special() {
  return (
    <div>
      <h2 className="special-education-heading">Special Education</h2>

      <motion.div
        className="container"
        initial={{ x: "-100vw", opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{ type: "tween", duration: 3 }}
      >
        <p>
          Special education is customized instruction designed to meet the
          unique needs of children with disabilities. It uses individualized
          educational programs (IEPs), specialized materials, and tailored
          teaching methods to support students with physical, mental, emotional,
          or learning challenges. The focus is on helping them achieve their
          potential and prepare for independent living through child-centered,
          functional, and activity-based learning. Students are grouped by
          developmental level, from Care group to Vocational, and taught using a
          mix of one-on-one sessions, group work, and digital tools. Emphasis is
          placed on daily living skills, core academic areas, and preparation
          for key exams like Class 10 and +2. Teachers work closely with
          parents, providing regular updates and home-learning strategies, while
          also collaborating with therapists, social workers, and school staff
          to support each student’s academic, social, and emotional growth.
        </p>
      </motion.div>
    </div>
  );
}

export default Special;
